import React from 'react';
import { X, AlertTriangle, CheckCircle, Info } from 'lucide-react';

const NotificationToast = ({ alert, onClose }) => {
  const { id, title, message, type } = alert;

  // Determine icon and colors based on type
  let Icon = Info;
  let iconColor = "text-blue-500 dark:text-blue-400";
  let borderColor = "border-blue-500 dark:border-blue-400";

  if (type === "error") {
    Icon = AlertTriangle;
    iconColor = "text-red-500 dark:text-red-400";
    borderColor = "border-red-500 dark:border-red-400";
  } else if (type === "success") {
    Icon = CheckCircle;
    iconColor = "text-green-500 dark:text-green-400";
    borderColor = "border-green-500 dark:border-green-400";
  }

  return (
    <div
      // Added arbitrary values for the slide-in animation [translateX(100%)]->[translateX(0)]
      className={`max-w-sm w-80 bg-white dark:bg-gray-800 border-l-4 ${borderColor} rounded-lg shadow-lg dark:shadow-xl p-4 mb-3 transition-all duration-300 transform animate-[slideIn_0.3s_ease-out]`}
      role="status"
      aria-live="polite"
    >
      <div className="flex justify-between items-start gap-3">
        <div className="flex items-start gap-3">
          {/* Icon Container */}
          <div className={`flex-shrink-0 mt-0.5 ${iconColor}`}>
            <Icon size={20} />
          </div>
          
          {/* Content */}
          <div className="flex-1">
            <div className="font-semibold text-gray-900 dark:text-white text-sm">{title}</div>
            {message && (
              <div className="text-xs mt-1 leading-snug text-gray-500 dark:text-gray-400">
                {message}
              </div>
            )}
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={() => onClose(id)}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors flex-shrink-0"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export const NotificationStack = ({ alerts, onRemove }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {alerts.map((alert) => (
        <NotificationToast key={alert.id} alert={alert} onClose={onRemove} />
      ))}
    </div>
  );
};